import {Route, Routes} from "react-router-dom";
import {Routes as R} from "../utils";
import {ConfigurationContainer, CustomerContainer, SummaryContainer, ViewContainer} from "../containers";
import {Footer, Header} from "../components";
import HomeContainer from "../containers/HomeContainer";
import {AppProvider} from "./index";
import OrderFinalizedScreen from "../screens/OrderFinalizedScreen";

export default function Navigation(props) {
    return (
        <AppProvider>

            <div className="container">
                <Header/>
            </div>

            <main className="pt-5 pb-5">
                <Routes>
                    <Route exact path={R.home} element={<HomeContainer/>}/>
                    <Route exact path={R.configuration} element={<ConfigurationContainer/>}/>
                    <Route exact path={R.view} element={<ViewContainer/>}/>
                    <Route exact path={R.customer} element={<CustomerContainer/>}/>
                    <Route exact path={R.summary} element={<SummaryContainer/>}/>
                    <Route exact path={R.orderFinalized} element={<OrderFinalizedScreen/>}/>
                </Routes>
            </main>

            <div className="container">
                <Footer/>
            </div>

        </AppProvider>
    )
}
